/** 锚点定位 */
import { useEventListener } from "@vueuse/core";

export const anchor = {
  mounted: (el, binding) => {
    const { arg, value } = binding;
    useEventListener(el, "click", () => {
      /*找到锚点*/
      let anchorElement = document.getElementById(value);
      /*如果对应id的锚点存在，就跳转到锚点*/
      if (anchorElement) {
        anchorElement.scrollIntoView();
      }
    });
  },
  beforeUnmount(el) {}
};
